
// const showFiguresTooltipHandler = (event) => {
//   document.querySelector("#figures-tooltip").style.display = "block";
// };

// const hideFiguresTooltipHandler = () => {
//   document.querySelector("#figures-tooltip").style.display = "none";
// };

const KeyFiguresSection = (props) => {
  const tooltipHeight = 110;
  return (
    <div
      className="key-figures-wrapper"
      style={{
        top: props.height,
        width: props.tooltipWidth,
        display: props.tooltipStatus && props.tooltipStatus.content ? "block" : "none"
      }}
    >
      {props.tooltipStatus && (
        <div>
          <p className="f-med mxy-5">
            <strong>
              {props.tooltipStatus && props.tooltipStatus.country}
            </strong>
          </p>
          <p className="f-small mxy-5">
            {props.tooltipStatus && props.tooltipStatus.content}
          </p>
          {props.tooltipStatus.link && (
            <p className="f-small mxy-10">
              <a href={props.tooltipStatus.link}>Read More</a>
            </p>
          )}
        </div>
      )}
      {/* <div style={{ position: "relative" }}>
        <h4 className="mxy-0 f-smed" style={{ paddingTop: 5 }}>
          {props.countryShown ? "Key Figures" : "Key Figures (region)"}
        </h4>
        <span
          onMouseOver={(event) => showFiguresTooltipHandler(event)}
          onMouseOut={() => hideFiguresTooltipHandler()}
          style={{
            position: "absolute",
            top: -6,
            left: props.tooltipWidth - 18,
            cursor: "pointer",
          }}
        >
          &#8505;
        </span>
        <div
          id="figures-tooltip"
          className="hover-tooltip"
          style={{ transform: "translate(101%,-150%)" }}
        >
          <p>
            Some text explaning date specifications for month and year
            comparison figures
          </p>
        </div>
        <div
          id="summary_stats"
          style={{ display: "flex", paddingTop: 5, paddingBottom: 10 }}
        >
          <KeyFigureSingle
            figure={props.keyFigures.month}
            interval="month"
            period={props.period}
          />
          <KeyFigureSingle
            figure={props.keyFigures.year}
            interval="year"
            period={props.period}
            showTooltipHandler={props.showTooltipHandler}
            hideTooltipHandler={props.hideTooltipHandler}
            moveTooltipHandler={props.moveTooltipHandler}
          />
        </div>
      </div> */}
    </div>
  );
};

export default KeyFiguresSection;
